import Vue from 'vue'
// import '@/assets/css/reset.css'
import App from './App.vue'
import router from './router'
import 'ant-design-vue/dist/antd.less'
import '@/assets/css/theme.less'
import moment from 'moment'
import Antd from 'ant-design-vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
import '@/components/index' // 公共组件注册
import infiniteScroll from 'vue-infinite-scroll' // 滚动条加载数据
import SlideVerify from 'vue-monoplasty-slide-verify'
import AMap from 'vue-amap'

// import '@/utils/uploadFile'
Vue.use(AMap)
// 公司注册的高德-web服务-key
Vue.prototype.$mapKey = '13e395346a1f788d97404dc5e8f6d95e'
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: 'd82903fe6eabaa23d169d9ad2164e366', // 公司账户注册的-web端js-key
  // 插件集合 （插件按需引入）
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor'
  ]
})

Vue.use(Antd)
Vue.use(SlideVerify)
Vue.use(infiniteScroll)
Vue.config.productionTip = false
Vue.prototype.moment = moment
moment.locale('zh-cn')
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    sessionStorage.removeItem('username')
  }
  let user = sessionStorage.getItem('username')
  if (!user && to.path !== '/login') {
    next({ path: '/login' })
  } else {
    NProgress.start()
    next()
  }
})

// 公共右侧通知弹窗函数>>$notification
Vue.prototype.notification = function (type, msg, desc) {
  this.$notification[type]({
    message: msg,
    description: desc
  })
}

router.afterEach(transition => {
  NProgress.done()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
